import { useState, useCallback } from 'react';
import { pw2202Api, F2120 } from '../../../services/pw2202Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master record */
  const resolveAllNames = useCallback(async (data: Partial<F2120>) => {
    const entries: [string, string, string][] = [
      ['warehouse', 'warehouse', data.f2120_07 || ''],
      ['employee', 'employee', data.f2120_12 || ''],
      ['vendor', 'vendor', data.f2120_13 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pw2202Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pw2202Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
